// Customer reviews used by the ReviewsMarquee component on the home page.
// Each review: { quote, name, attribution }

export const DOCK_LIFT_REVIEWS = [
  {
    quote:
      '“Absolute came out to quote my job within 48 hours and got all the work done 2 weeks later — exactly as agreed.”',
    name: 'Jason H.',
    attribution: 'Sarasota, FL',
  },
  {
    quote:
      '“I needed my dock repaired quickly because I had family coming to visit. They moved some things around and did the work quickly.”',
    name: 'Michelle D.',
    attribution: 'Fort Myers, FL',
  },
  {
    quote:
      '“Boat lift and dock destroyed by Ian. Absolute had their crew out within 3 weeks and all the work was completed within a month.”',
    name: 'Robert M.',
    attribution: 'Venice, FL',
  },
  {
    quote:
      '“What a great group of guys! They worked quickly and respectfully — such a pleasure to work with. Highly recommend.”',
    name: 'Rosemary W.',
    attribution: 'Englewood, FL',
  },
];

export const BARGE_REVIEWS = [
  {
    quote:
      '"I am writing this review as a licensed marine contractor in the state of Florida. I purchased one of their air hammers and it has been the best one my company has owned to date. Everything I had seen done wrong by other manufacturers they corrected. I will definitely buy from them again."',
    name: 'Charles Hodges',
    attribution: 'Licensed FL Marine Contractor',
    model: 'Verified Google review · Absolute Hammer owner',
    rating: 5,
  },
  {
    quote:
      '"Rafter C Docks bought a 10x30 barge from Absolute Marine Equipment! Wanderson and his team are top notch! I would highly recommend!"',
    name: 'Chris Crider',
    attribution: 'Rafter C Docks',
    model: "Verified Google review · Purchased a 10' × 30' Absolute HDPE Barge",
    rating: 5,
  },
  {
    quote:
      '"I purchased my barge from them and it is extremely durable and well built, they\u2019re made to actually hold up to hard work. We\u2019ve put ours to good use and they\u2019ve handled everything we\u2019ve thrown at them without any issues. The quality is definitely there, and I feel like I got a great product. If you\u2019re looking for a reliable, heavy-duty barge that\u2019s going to last, I\u2019d definitely recommend."',
    name: 'Justin Mulcahy',
    attribution: 'Verified Google review · Local Guide',
    model: 'Purchased an Absolute HDPE Barge',
    rating: 5,
  },
  {
    quote:
      '"Great product, quick delivery. Price and quality makes it a no brainer."',
    name: 'Jack H.',
    attribution: 'Gulfshore Marine',
    model: "Purchased a 24' Absolute HDPE Barge",
    rating: 5,
  },
];
